import React from 'react';
import Divider from 'src/components/10-atoms/Divider';
import ReadingColumn from 'src/components/10-atoms/layout/ReadingColumn';
import LoaderBase from 'src/components/10-atoms/loaders/LoaderBase';
import TextLoader from 'src/components/10-atoms/loaders/TextLoader';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import styleUtils from 'src/utils/styles';
/** Skeleton for QuestionReadingContent — same ReadingColumn shell + sections. */
const QuestionReadingLoader = () => {
    const [{ theme }] = useTheme();
    return (React.createElement(ReadingColumn, { flex: true },
        React.createElement(LoaderBase, { style: { height: 90 }, ph: theme.spacing.page, mv: theme.spacing.standard.sm }),
        React.createElement(Divider, { mb: theme.spacing.standard.xs }),
        React.createElement(TextLoader, { mt: theme.spacing.standard.sm, style: styleUtils.pagePadding, height: 24, lines: 5 })));
};
export default QuestionReadingLoader;
